import React from "react";
import { Box, Text, Flex, Image, BackgroundImage, Stack, Card } from "@mantine/core";

import FCALOGO from "./assets/ALCOMM_LOGO.png";
import appleDownloadImg from "./assets/apple_download.png";
import gooleDownloadImg from "./assets/google_download.png";
import bannerBackground from "./assets/background.png";
import BannerBottom from "./assets/background_bottom.png";
import BannerMainIllustration from "./assets/main-illustration.png";
import { ReactComponent as DownloadTextSVG } from "./assets/Download-text.svg";
import { ReactComponent as AlcommAppSVG } from "./assets/alcomm app.svg";

import "./index.scss";

const DownloadBanner = () => {
	return (
		<BackgroundImage pos={'relative'} src={bannerBackground} style={{ overflow: 'hidden' }}>
			<Flex align={'center'} justify={'center'}>
				<Card
					flex="1 1 auto"
					style={{
						gap: 30,
						flexDirection: 'row-reverse',
						justifyContent: "center"
					}}
					my="xl"
					gap={0}
					bg={'transparent'}
					pt={{ base: "xs", md: "md" }}
					px={'md'}
				>
					<Box w={'max(50%,300px)'} style={{ zIndex: 1, alignSelf: "center" }} >
						<Image
							component="img"
							alt="phone"
							src={FCALOGO}
							h="auto"
							w={150}
							fit="contain"
						/>
						<Flex direction="row" mt={10} columnGap={10} mb={5} wrap={'wrap'} >
							<DownloadTextSVG width={220} height={'40px'} />
							<AlcommAppSVG width={200} height={'40px'} />
						</Flex>

						<Text fz={'md'} fw={500} mb={5} lh='1em'>
							Please click on the link to download the ALCOMM app to be
							part of SDA's Alumni.
						</Text>
						<Text fw={600} mb={5} mt={20}>
							SDA's Alumni benefits:
						</Text>
						{[
							"View your upcoming course information",
							"Select your meals",
							"Enroll for new courses",
							"Reschedule your courses",
							"Download certificates",
							"Receive updates on digital news and trends",
						].map((benefit, index) => (
							<Flex key={index} direction="row" mb={5} align={'center'}>
								<Flex
									bg="#00ab84"
									p={5}
									justify="center"
									align="center"
									style={{ alignSelf: "flex-start", borderRadius: "50%" }}
									mr={5}
								>
									<i className="fa fa-check" style={{ color: "white", fontSize: "0.8em" }} aria-hidden="true"></i>
								</Flex>
								<Text>
									{benefit}
								</Text>
							</Flex>
						))}
						<Flex gap={10} mt={10} wrap={'wrap'}>
							<Box
								component="img"
								alt="apple_download"
								src={appleDownloadImg}
								onClick={() => window.open(process.env.REACT_APP_APPLE_APP_STORE_URL, "_blank")}
								w='160px'
								h='auto'
								object-fit='contain'
								style={{ cursor: 'pointer' }}
							/>
							<Box
								component="img"
								alt="google_download"
								src={gooleDownloadImg}
								onClick={() => window.open(process.env.REACT_APP_ANDROID_APP_STORE_URL, "_blank")}
								w='160px'
								h='auto'
								object-fit='contain'
								style={{ cursor: 'pointer' }}
							/>
						</Flex>
					</Box>
					<Flex w={'min40%,400px)'} visibleFrom="xs">
						<Image
							src={BannerMainIllustration}
							alt="banner_main_illustration"
							fit="contain"
							flex={1}
						/>
					</Flex>
				</Card>
			</Flex>

			<Image src={BannerBottom}
				pos={'absolute'}
				bottom={0}
				left={0}
				w={'100%'}
				h={'auto'}
				style={{ zIndex: 0 }}
				opacity={1}
			/>

			<Image
				src={BannerMainIllustration}
				pos={'absolute'}
				w={'70%'}
				h={'auto'}
				bottom={0}
				right={20}
				style={{ zIndex: 0 }}
				opacity={0.05}
				hiddenFrom="xs"
			/>
		</BackgroundImage >
	);
};




export default DownloadBanner;
